import { render, staticRenderFns } from "./IconRecommended.vue?vue&type=template&id=812436e8"
import script from "./IconRecommended.vue?vue&type=script&lang=js"
export * from "./IconRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports